var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown-btn"},[_c('div',{staticClass:"wrapper",on:{"click":_vm.onComplete}},[_vm._v(_vm._s(_vm.copy)+"("+_vm._s(_vm.local_countdown)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }